// deprecated, use v3 series
export const JOB_BASE_TYPES = Object.freeze({
  wi: 'Walk-in',
  vwi: 'Verified Walk-in',
})
export const JOB_EXTS = Object.freeze({
  xd: 'Cross Device',
  ppst: 'Propensity',
  aoi: 'AOI',
  legacy: 'Legacy',
  xwi: 'Cross Chain Walk-in', // TODO: a base type in v3 builder
})
export const JOB_TYPES = Object.freeze({
  ...JOB_EXTS,
  ...JOB_BASE_TYPES,
})
export const formatTypes = (raw) => raw.split(/[,_]/).map((type) => (JOB_TYPES[type] || type || 'N/A'))

export const JOB_TYPES_V3 = Object.freeze({
  wi: 'Walk-in',
  vwi: 'Verified Walk-in',
  xwi: 'Cross Chain Walk-in', // TODO: a base type in v3 builder
})
export const JOB_EXTS_V3 = Object.freeze({
  xd: 'Cross Device',
  ppst: 'Propensity',
  aoi: 'AOI',
})

export const specialJobs = (n) => n
  .split('_')
  .filter((p) => p.toLowerCase() !== 'bell')
  .join(' ')
  .replace(/\b\w/, (l) => l.toUpperCase())
export const getType = (raw) => JOB_TYPES_V3[raw.split(/[,_]/).find((t) => JOB_TYPES_V3[t])] || specialJobs(raw) || raw
export const mapExts = (raw) => raw.split(/[,_]/).map((t) => JOB_EXTS_V3[t]).filter((t) => t)

export const JOB_STATES = Object.freeze({
  PENDING: 'yellow',
  DELETED: 'grey',
  FINISHED: 'blue',
  SCHEDULED: 'green',
  RUNNING: 'teal',
  FAILED: 'red',
})
